<script>
	import { Router, Route } from "svelte-routing";
	import Index from "./view/Index.svelte";
	import About from "./view/About.svelte";
	import Categories from "./view/cat.svelte";
	import BuyPrice from "./view/cost.svelte";
	import SellPrice from "./view/price.svelte";
	import Account from "./view/user.svelte";
	import CashFlow from "./view/cash.svelte";
	import CloseCash from "./view/close.svelte";
	import VideoDemo from "./view/webapp.svelte";
  
	export let url = "";
  </script>
    <Router url="{url}">
	<Route path="/" component="{Index}" />
	<Route path="/about" component="{About}" />
	<Route path="/cat" component="{Categories}" />
	<Route path="/cost" component="{BuyPrice}" />
	<Route path="/price" component="{SellPrice}" />
	<Route path="/user" component="{Account}" />
	<Route path="/cash" component="{CashFlow}" />
	<Route path="/close" component="{CloseCash}" />
	<Route path="/webapp" component="{VideoDemo}" />
  </Router>
